<template>
  <section :class="{pt: true, open: ptOpen}">
    <div class="awanL"></div>
    <div class="awanR"></div>
    <div :class="{ptCenter: true, an: centerAn}" v-if="centerOpen">
      <div class="nanas"></div><div class="awan"></div>
      <div class="logo"></div><div class="buah1"></div>
      <div class="buah2"></div>
    </div>
    <div :class="{ptBg: true, an: centerAn}" v-if="centerOpen"></div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ptOpen: false,
      centerOpen: false,
      centerAn: false,
    };
  },
  computed: {},
  methods: {
    open() {
      this.ptOpen = true;
      this.centerOpen = true;
      setTimeout(() => {
        this.centerAn = true;
      });
      setTimeout(() => {
        this.close();
      }, 800);
    },
    close() {
      this.ptOpen = false;
      this.centerAn = false;
      setTimeout(() => {
        this.centerOpen = false;
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
.pt{
  position: relative;
  z-index: 9999;
  .awanL{
    position: fixed;
    left: 0; bottom: 0; top: 0;
    width: 80%;
    left: -80%;
    transition: all .5s ease;
    background-image: url(../assets/Transitioncloud-left.png);
    background-size: cover;
    background-position: right center;
    background-repeat: no-repeat;
    z-index: 3;
    @media (max-width: 680px) {
      width: 120%; left: -120%;
    }
  }
  .awanR{
    position: fixed;
    right: 0; bottom: 0; top: 0;
    width: 80%;
    right: -80%;
    transition: all .5s ease;
    background-image: url(../assets/Transitioncloud-right.png);
    background-size: cover;
    background-position: left center;
    background-repeat: no-repeat;
    z-index: 3;
    @media (max-width: 680px) {
      width: 120%; right: -120%;
    }
  }
  .ptCenter{
    width: 400px;
    height: 400px;
    position: fixed;
    left: 50%; top: 50%;
    margin-top: -200px;
    margin-left: -200px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    opacity: 0;
    transition: all .4s ease;
    &.an{
      opacity: 1;
    }
    .logo{
      width: 300px; height: 300px;
      background-image: url(../assets/logo.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;
      z-index: 9;
      animation: fruitAnimation2 14s infinite ease;
    }
    .nanas{
      width: 80px; height: 80px;
      background-image: url(../assets/Mainstage-Buah1.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 20px; top: 20px;
      z-index: 2;
      animation: fruitAnimation 8s infinite ease;
    }
    .buah1{
      width: 80px; height: 80px;
      background-image: url(../assets/Mainstage-Buah3.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 40px; bottom: 60px;
      z-index: 2;
      animation: fruitAnimation 8s infinite ease;
    }
    .buah2{
      width: 80px; height: 80px;
      background-image: url(../assets/Mainstage--Buah2.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      left: 20px; top: 100px;
      z-index: 2;
      animation: fruitAnimation 8s infinite ease;
    }
    .awan{
      width: 300px; height: 300px;
      background-image: url(../assets/Mainstage-Awan3.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      left: 20px; top: 100px;
      z-index: 1;
    }
  }
  .ptBg{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    z-index: 1;
    background-color: #fff;
    transition: all .4s ease;
    opacity: 0;
    &.an{
      opacity: .7;
    }
  }
  &.open{
    .awanL{
      left: 0;
    }
    .awanR{
      right: 0;
    }
  }
}

@keyframes fruitAnimation {
  0% {transform: translateY(0);}
  50% {transform: translateY(14px);}
  100% {transform: translateY(0);}
}
@keyframes fruitAnimation2 {
  0% {transform: translateY(14px);}
  50% {transform: translateY(0);}
  100% {transform: translateY(14px);}
}
</style>
